export default __webpack_public_path__ + "alert-fill-attention.934d1d35898bbd46.svg";